module.exports = __webpack_public_path__ + "static/img/incheon-paralympic-pt.8b6cfd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/incheon-paralympic-pt.jpg
// module id = wzhD
// module chunks = 0